import React from 'react';

import {
    Col,
    FormGroup,
    Input,
    Label,
    FormFeedback,
    InputGroup,
    InputGroupAddon
} from 'reactstrap';

import { Field } from 'formik';
import { InfoTooltip } from './InfoTooltip';

export const InputText = (props) => {

    const { col, name, label, placeholder, plusChange, suffix, preffix, renderInfoTooltip,
        titleInfoTooltip, msgInfoTooltip, bottomText, autoComplete } = props;

    return (
        <Col md={col}>

            <FormGroup>

                <Label htmlFor={'id_' + name} >{label} {" "}
                    {
                        renderInfoTooltip ?
                            <InfoTooltip
                                id={'idtool_' + name.split('.').shift()}
                                title={titleInfoTooltip}
                                msg={msgInfoTooltip}
                            />
                            : <React.Fragment />
                    }
                </Label>
                <Field name={name}>
                    {({ field, form, meta }) => (
                        <>
                            <InputGroup>
                                <InputGroupAddon addonType="append">{preffix}</InputGroupAddon>
                                <Input
                                    {...field}
                                    name={name}
                                    value={field.value ?? ''}
                                    type={props.type}
                                    placeholder={placeholder}
                                    id={'id_' + name}
                                    invalid={meta.error && meta.touched}
                                    className='form-control'
                                    autoComplete={autoComplete}
                                    data-a-sign="" data-a-dec="," data-a-sep="."
                                    disabled={props.disabled}
                                    style={{
                                        borderColor: meta.error && meta.touched ? 'red' : 'none',
                                        backgroundColor: props.disabled ? '#e9ecef' : 'white',
                                        cursor: props.disabled ? 'not-allowed' : 'text',
                                        borderRadius: '4px',
                                        minHeight: '37px',
                                    }}
                                    onChange={(e) => {
                                        form.handleChange(e);
                                        plusChange(e);
                                    }}
                                />
                                <InputGroupAddon addonType="append">{suffix}</InputGroupAddon>
                                <FormFeedback>{meta.error}</FormFeedback>
                            </InputGroup>
                            <span style={{ fontStyle: 'italic', fontSize: '12px' }}>{bottomText}</span>
                        </>
                    )}
                </Field>
            </FormGroup>

        </Col>
    )

};

InputText.defaultProps = {
    col: 12,
    type: 'text',
    renderInfoTooltip: false,
    titleInfoTooltip: 'Informação',
    autoComplete: "off",
    disabled: false,
    plusChange: () => { }
};